import { render, staticRenderFns } from "./ResidentialComplexes.vue?vue&type=template&id=39a114e7&scoped=true"
import script from "./ResidentialComplexes.vue?vue&type=script&lang=js"
export * from "./ResidentialComplexes.vue?vue&type=script&lang=js"
import style0 from "./ResidentialComplexes.vue?vue&type=style&index=0&id=39a114e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a114e7",
  null
  
)

export default component.exports